export function initMap(url) {
	console.log(url);
	// CHECK IF #HTM_MAPENTRIES EXISTS IN THE DOM
	let mapEntries = document.getElementById('htm_mapEntries');
	if (!mapEntries) {
		return;
	}
	// CREATE GOOGLE MAP
	// MAP STYLE
	let mapStyle = new google.maps.StyledMapType(
		[{
				"featureType": "administrative",
				"elementType": "labels.text.fill",
				"stylers": [{
					"color": "#6195a0"
				}]
			},
			{
				"featureType": "administrative.province",
				"elementType": "geometry.stroke",
				"stylers": [{
					"visibility": "off"
				}]
			},
			{
				"featureType": "landscape",
				"elementType": "geometry",
				"stylers": [{
						"lightness": "0"
					},
					{
						"saturation": "0"
					},
					{
						"color": "#f5f5f2"
					},
					{
						"gamma": "1"
					}
				]
			},
			{
				"featureType": "landscape.man_made",
				"elementType": "all",
				"stylers": [{
						"lightness": "-3"
					},
					{
						"gamma": "1.00"
					}
				]
			},
			{
				"featureType": "landscape.natural.terrain",
				"elementType": "all",
				"stylers": [{
					"visibility": "off"
				}]
			},
			{
				"featureType": "poi",
				"elementType": "all",
				"stylers": [{
					"visibility": "off"
				}]
			},
			{
				"featureType": "poi.park",
				"elementType": "geometry.fill",
				"stylers": [{
						"color": "#bae5ce"
					},
					{
						"visibility": "on"
					}
				]
			},
			{
				"featureType": "road",
				"elementType": "all",
				"stylers": [{
						"saturation": -100
					},
					{
						"lightness": 45
					},
					{
						"visibility": "simplified"
					}
				]
			},
			{
				"featureType": "road.highway",
				"elementType": "all",
				"stylers": [{
					"visibility": "simplified"
				}]
			},
			{
				"featureType": "road.highway",
				"elementType": "geometry.fill",
				"stylers": [{
						"visibility": "simplified"
					},
					{
						"color": "#fee0cd"
					}
				]
			},
			{
				"featureType": "road.highway",
				"elementType": "labels",
				"stylers": [{
					"visibility": "off"
				}]
			},
			{
				"featureType": "road.highway",
				"elementType": "labels.text",
				"stylers": [{
					"color": "#4e4e4e"
				}]
			},
			{
				"featureType": "road.arterial",
				"elementType": "labels.text.fill",
				"stylers": [{
					"color": "#787878"
				}]
			},
			{
				"featureType": "road.arterial",
				"elementType": "labels.icon",
				"stylers": [{
					"visibility": "off"
				}]
			},
			{
				"featureType": "transit",
				"elementType": "all",
				"stylers": [{
					"visibility": "simplified"
				}]
			},
			{
				"featureType": "transit.station.airport",
				"elementType": "labels.icon",
				"stylers": [{
						"hue": "#0a00ff"
					},
					{
						"saturation": "-77"
					},
					{
						"gamma": "0.57"
					},
					{
						"lightness": "0"
					}
				]
			},
			{
				"featureType": "transit.station.rail",
				"elementType": "labels.text.fill",
				"stylers": [{
					"color": "#43321e"
				}]
			},
			{
				"featureType": "transit.station.rail",
				"elementType": "labels.icon",
				"stylers": [{
						"hue": "#ff6c00"
					},
					{
						"lightness": "4"
					},
					{
						"gamma": "0.75"
					},
					{
						"saturation": "-68"
					}
				]
			},
			{
				"featureType": "water",
				"elementType": "all",
				"stylers": [{
						"color": "#eaf6f8"
					},
					{
						"visibility": "on"
					}
				]
			},
			{
				"featureType": "water",
				"elementType": "geometry.fill",
				"stylers": [{
					"color": "#c7eced"
				}]
			},
			{
				"featureType": "water",
				"elementType": "labels.text.fill",
				"stylers": [{
						"lightness": "-49"
					},
					{
						"saturation": "-53"
					},
					{
						"gamma": "0.79"
					}
				]
			}
		]
	);

	let map = new google.maps.Map(
		mapEntries, {
			zoom: 7,
			center: {
				lat: 56.2128537,
				lng: 10.300139
			},
			disableDefaultUI: true,
		}
	);

	map.mapTypes.set("styled_map", mapStyle);
  	map.setMapTypeId("styled_map");

	// FETCH ALL GARDENS
	fetch(url)
		.then(response => response.json())
		.then(data => {
			let gardens = data.gardens;
			let listContainer = document.getElementById('htm_list-container');
			let listItemTemplate = document.getElementById('htm_garden-template');
			let markers = [];
			gardens.map(garden => {
				let icon = {
					path: 'M172.268 501.67C26.97 291.031 0 269.413 0 192 0 85.961 85.961 0 192 0s192 85.961 192 192c0 77.413-26.97 99.031-172.268 309.67-9.535 13.774-29.93 13.773-39.464 0zM192 272c44.183 0 80-35.817 80-80s-35.817-80-80-80-80 35.817-80 80 35.817 80 80 80z',
					fillColor: `${(garden.category_name === 'Selvstændige Haver til Maver') ? '#eea922' : (garden.category_name === 'Haver til Maver') ? '#51715a' : '#ff6036'}`,
					//fillColor: `${(garden.category_name === 'Andre skolehaver') ? '#ff6036' : (garden.category_name === 'Vores skolehaver') ? '#eea922' : '#417e50'}`,
					fillOpacity: 1,
					scale: .04,
					strokeOpacity: 0,
					anchor: new google.maps.Point(193, 517)
				};
				let contentString = `<div class="htm_info-window">`;
				if (garden.title) {
					contentString += `<p class="htm_info-window title">${garden.title}</p>`;
				}
				if (garden.address) {
					contentString += `<p class="htm_info-window address">${garden.address}</p>`;
				}
				if (garden.region) {
					contentString += `<p class="htm_info-window region">${garden.region}</p>`;
				}
				// if(garden.category_name){
				// 	contentString += `<p class="htm_info-window category">${garden.category_name}</p>`;
				// }
				if (garden.phone) {
					contentString += `<a href="tel:${garden.phone}" target="_blank" class="htm_info-window phone">${garden.phone}</a>`;
				}
				if (garden.email) {
					contentString += `<a href="mailto:${garden.email}" target="_blank" class="htm_info-window email">${garden.email}</a>`;
				}
				if (garden.facebook) {
					contentString += `<a href="${garden.facebook}" target="_blank" class="htm_info-window facebook">Besøg Facebookside</a>`;
				}
				if (garden.website) {
					contentString += `<a href="${garden.website}" target="_blank" class="htm_info-window website">Besøg Hjemmeside</a>`;
				}
				contentString += `</div>`; // end htm_info-window
				let infoWindow = new google.maps.InfoWindow({
					content: contentString,
				});
				const mapMarkersFilter = (catTitle, gardenCatTitle, haverTitle) => {
					if((catTitle !== 'undefined') && (gardenCatTitle !== 'undefined') && (catTitle === gardenCatTitle) && (garden.title === haverTitle)){
						let marker = new google.maps.Marker({
							position: {
								lat: parseFloat(garden.lat),
								lng: parseFloat(garden.lng)
							},
							map,
							title: garden.title,
							icon,
							infoWindow,
						});
						// Loop for closing all other info windows
						//console.log('gggg', garden)
						
						markers.push(marker);
						//marker.setMap(map)
						google.maps.event.addListener(marker, 'click', e => {
							markers.forEach(m => {
								m.infoWindow.close(map, m);
							});
							infoWindow.open(map, marker);
						});
					} 
				}
				let clone = listItemTemplate.content.cloneNode(true);
				if (garden.title) {
					clone.querySelector('.title').textContent = garden.title;
					clone.querySelector('.htm_list-item.garden').setAttribute('data-title', garden.title);
				}
				if (garden.category_name) {
					//clone.querySelector('.category').textContent = garden.category_name;
					clone.querySelector('.htm_list-item.garden').setAttribute('datacategory', garden.category_name);
				}
				if (garden.address) {
					clone.querySelector('.address').textContent = garden.address;
					clone.querySelector('.htm_list-item.garden').setAttribute('data-address', garden.address);
				}
				if (garden.region) {
					clone.querySelector('.region').textContent = garden.region;
					clone.querySelector('.htm_list-item.garden').setAttribute('data-region', garden.region);
				}
				if (garden.phone) {
					clone.querySelector('.contact .contact__phone').setAttribute('href', `tel:${garden.phone}`);
					clone.querySelector('.contact .contact__phone').textContent = garden.phone;
				}
				if (garden.email) {
					clone.querySelector('.contact .contact__email').setAttribute('href', `mailto:${garden.email}`);
					clone.querySelector('.contact .contact__email').textContent = garden.email;
				}
				if (garden.facebook) {
					clone.querySelector('.social__facebook').setAttribute('href', `${garden.facebook}`);
				} else {
					clone.querySelector('.social__facebook').style.display = 'none';
				}
				if (garden.website) {
					clone.querySelector('.social__website').setAttribute('href', `${garden.website}`);
				} else {
					clone.querySelector('.social__website').style.display = 'none';
				}
				listContainer.appendChild(clone);
				/************************ (Vores /Andre /Alle) categories filtering ****************************/
				const selectFilterCat = Array.from(document.querySelectorAll('.filter-category'));
				//const allGardens = document.querySelectorAll('.htm_list-item');
				const allGardens = Array.from(document.querySelectorAll('.htm_list-item.garden'));
				selectFilterCat.forEach(cat => cat.addEventListener('click', e =>{

						/********** Vores skolehaver button filtering --- Haver til Maver  ***********/
					if(cat?.innerHTML === 'Haver til Maver'){
						/********** voresbutton active, and remove active classes for other two buttons *********/
						cat.classList.add('voresActive')
						if(document.querySelector('.voresActive')){
							selectFilterCat.forEach((c) => {
								c.classList.remove('alleActive')
								c.classList.remove('andreActive')
							})
						}
						
						allGardens && Object.values(allGardens).filter(i => { 
							//console.log('allGardens', allGardens,'selectFilterCat', selectFilterCat, '****',i?.attributes?.dataCategory?.value, '@@', garden?.category_name,'@@@@@@', i?.dataset?.title, garden?.title)
							if((i?.attributes?.dataCategory?.value !== 'undefined') && (garden?.category_name !== 'undefined') && (i?.attributes?.dataCategory?.value === ('Haver til Maver'))){
								mapMarkersFilter(i?.attributes?.dataCategory?.value, garden?.category_name, i?.dataset?.title)
								return  i.style.display = 'grid'; 
								//i.style.padding = '10px'
							} else {
								i.style.display = 'none'
							}
							//map markers/pins filtering for vores skolehaver
							markers.filter((ma) => {
								if(ma.title === garden.title){
									ma.setVisible(false);
								}
							})
							// i.style.background = '#eea922'
						})
						
						/********** Andre skolehaver button filtering --- Selvstændige Haver til Maver ***********/
					} else if(cat?.innerHTML === 'Selvstændige Haver til Maver'){
						/********** andrebutton active, and remove active classes for other two buttons *********/
						cat.classList.add('andreActive');
						if(document.querySelector('.andreActive')){
							selectFilterCat.forEach((c) => {
								c.classList.remove('voresActive')
								c.classList.remove('alleActive')
							})
						}

						allGardens && Object.values(allGardens).filter(i => { 
							//console.log('allGardens', allGardens,'selectFilterCat', selectFilterCat, '****',i?.attributes?.dataCategory?.value, '@@', garden?.category_name,'@@@@@@', i?.dataset?.title, garden?.title)
							if((i?.attributes?.dataCategory?.value !== 'undefined') && (garden?.category_name !== 'undefined') && (i?.attributes?.dataCategory?.value === ('Selvstændige Haver til Maver'))){
								mapMarkersFilter(i?.attributes?.dataCategory?.value, garden?.category_name, i?.dataset?.title)
								return  i.style.display = 'grid'; 
								//i.style.padding = '10px'
							} else {
								i.style.display = 'none'
							}
				
							//map markers/pins filtering for andre skolehaver
							markers.filter((ma) => {
								if(ma.title === garden.title){
									ma.setVisible(false);
								}
							})
						})

						/********** Alle button filtering ***********/

					} else if(cat?.innerHTML === 'Alle'){
						/********** allebutton active, and remove active classes for other two buttons *********/
						cat.classList.add('alleActive');
						if(document.querySelector('.alleActive')){
							selectFilterCat.forEach((c) => {
								c.classList.remove('voresActive')
								c.classList.remove('andreActive')
							})
						}
						Object.values(allGardens).map((item) => {
							mapMarkersFilter(item?.attributes?.dataCategory?.value, garden?.category_name, item?.dataset?.title)
							item.style.display = 'grid'; 
						})	
					}
				}))
					/********** Added colors for initial list view / alle list ***********/
				//initially active alle button
				selectFilterCat.filter(cat => cat?.innerHTML === 'Alle' && cat.classList.add('alleActive'))
				//each button have class for styling in inactive state
				selectFilterCat.forEach((cat) => {
					if(cat?.innerHTML === 'Haver til Maver'){
						return cat.classList.add('voresInActive')
					} else if(cat?.innerHTML === 'Selvstændige Haver til Maver'){
						return cat.classList.add('andreInActive')
					} else if(cat?.innerHTML === 'Alle'){
						return cat.classList.add('alleInActive')
					}
				})
				Object.values(allGardens).map((item) => {
					mapMarkersFilter(item?.attributes?.dataCategory?.value, garden?.category_name, item?.dataset?.title)
				})
				
			})
			prepareSortingBtns();
		});
}

function prepareSortingBtns() {

	let domGardens = Array.from(document.querySelectorAll('.garden'));
	let sortingTriggers = Array.from(document.querySelectorAll('.sorter'));

	sortingTriggers.forEach(trigger => {

		trigger.addEventListener('click', e => {

			// CATCH IF USER CLICKS ON SVG
			let elm = e.target;
			if (!e.target.classList.contains('sorter')) {
				while (!elm.classList.contains('sorter')) {
					elm = elm.parentNode;
				}
			}


			// RESET ACTIVE CLASS
			changeActive(elm, sortingTriggers);

			// POPULATE KEY, ORDER
			let key = '';
			let order = '';

			if (elm.classList.contains('asc')) {
				// SORT DESC
				order = 'desc'
				elm.classList.add('desc');
				elm.classList.remove('asc');

			} else if (elm.classList.contains('desc')) {
				// SORT ASC
				order = 'asc'
				elm.classList.add('asc')
				elm.classList.remove('desc')
			}

			// PREPARE TO SORT BASED ON DATA ATTRIBUTE
			switch (elm.getAttribute('data-sort')) {
				case 'title':
					key = 'data-title';
					break;
				case 'address':
					key = 'data-address';
					break;
				case 'region':
					key = 'data-region';
					break;
			}

			// console.log(key, order);
			let sorted = domGardens.sort(sortBy(key, order));
			resetList(sorted);
		})
	})
}



// ################################################## HELPERS ##################################################

// SORT BY KEY, ORDER
function sortBy(key, order = 'asc') {
	return function innerSort(a, b) {
		let aTitle = a.getAttribute(key);
		let bTitle = b.getAttribute(key);
		if (!aTitle || !bTitle) {
			return 0;
		}
		const varA = (typeof aTitle === 'string') ? aTitle.toUpperCase() : aTitle;
		const varB = (typeof bTitle === 'string') ? bTitle.toUpperCase() : bTitle;
		let comparison = 0;
		if (varA > varB) {
			comparison = 1;
		} else if (varA < varB) {
			comparison = -1;
		}
		return (
			(order === 'desc') ? (comparison * -1) : comparison
		);
	}
}

// RESET LIST OF GARDENS
function resetList(newList) {
	// console.log(newList);
	let listContainer = document.getElementById('htm_list-container');
	let oldList = Array.from(document.querySelectorAll('.htm_list-item.garden'));
	oldList.forEach(listItem => {
		listItem.remove()
	});
	newList.forEach(listItem => {
		listContainer.appendChild(listItem);
	});
}

// CHANGE ACTIVE CLASS
function changeActive(elm, sortingTriggers) {
	sortingTriggers.forEach(e => {
		if (e.classList.contains('active')) {
			e.classList.remove('active');
		}
	})

	if (!elm.classList.contains('active')) {
		elm.classList.add('active');
	}
}